<template>
  <div
    class="p-10"
    v-if="
      data!=null && 
      data.filter((x) => {
        return x.Remaining > 0;
      }).length > 0
    "
  >
    <div class="alert alert-warning m-0">
      Ödeme bekleyen
      <strong>{{
        data.filter((x) => {
          return x.Remaining > 0;
        }).length
      }}</strong>
      fatura vardır. Bunların toplamı
      <strong>
        {{ $formatPrice(data.reduce((a, b) => a + b.Remaining, 0)) }}
        {{
          data.filter((x) => {
            return x.Remaining > 0;
          })[0].Currency
        }}
      </strong>
      'dir.
    </div>
  </div>
  <dataTable
    :name="'CustomerProviders'"
    ref="agGrid"
    :data="data"
    :columnDefs="columnDefs"
    @removeFromRedis="removeFromRedis($event)"
    @scanErrors="scanErrorsPop = $event.Id"
    @scan="scan"
    @scanQue="scanQue"
    @update="updateShow = $event"
    @remove="remove"
    :rowClassRules="{
      // row style function
      danger: (params) => {
        // var numSickDays = params.data;
        return params?.data?.Status == 'overdue';
      },
      warning: (params) => {
        // var numSickDays = params.data;
        return params?.data?.Status == 'unpaid';
      },
    }"
  ></dataTable>
</template>

<script>
import moment from "moment";
import { formatPrice } from "@/utils/formatPrice";
export default {
  name: "SalesInvoices",
  props: {
    setModel: Object,
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: "InvoiceNo",
          field: "InvoiceNo",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 180,
        },
        {
          headerName: "Date",
          field: "Date",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY");
            }
          },
        },
        {
          headerName: "DueDate",
          field: "DueDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return moment(new Date(params.value)).format("DD.MM.YYYY");
            }
          },
        },
        {
          headerName: "Price",
          field: "Price",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return formatPrice(params.value) + " " + params.data.Currency;
            }
          },
        },
        {
          headerName: "Paid",
          field: "Paid",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return formatPrice(params.value) + " " + params.data.Currency;
            }
          },
        },
        {
          headerName: "Remaining",
          field: "Remaining",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 140,
          valueFormatter: function(params) {
            if (params.value == null) {
              return "";
            } else {
              return formatPrice(params.value) + " " + params.data.Currency;
            }
          },
        },
        {
          headerName: "DocumentUrl",
          field: "DocumentUrl",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
      ],
      data: null,
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`Parasut/Invoices/` + this.setModel.Id)
      .then((response) => {
        this.data = response.data;
      }).catch(err=>{
        this.$isError(err);
      });
  },
  methods: {
    scan(item) {
      this.scanResponseOpen = true;
      this.scanResponse = null;
      this.$appAxiosKolayrez
        .get(`Helpers/Scan/` + item.Id)
        .then((response) => {
          this.scanResponse = response.data;
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    scanQue(item) {
      this.$appAxiosKolayrez
        .post(`Timer/Scan`, {
          CustomerId: null,
          ProviderId: null,
          CustomerProviderId: item.Id,
        })
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Success",
            text: response.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.$isError(err);
        });
    },
    removeFromRedis(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the redis named " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviders/RemoveFromRedis/` + item.Id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer redis has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer provider named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`KOLAYREZ/CustomerProviders/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer provider has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
